// 我的车辆列表数据
export const  columns=[
    {
        title:'序号',
        type:'index'
    },
    {
        title:'车船号',
        dataIndex:"licensePlateNum",
        key:"licensePlateNum",
    },
    {
        title:'司机姓名',
        dataIndex:"driverName",
        key:"driverName"
    },
    {
        title:'手机号码',
        dataIndex:"driverPhone",
        key:"driverPhone"
    },
    {
        title:'身份证号',
        dataIndex:"driverIdCard",
        key:"driverIdCard"
    },
    {
      title:'押运员姓名',
      dataIndex:"escortsName",
      key:"escortsName"
    },
    {
        title:'押运员手机号',
        dataIndex:"escortsPhone",
        key:"escortsPhone"
    },
    {
        title:'押运员身份证号',
        dataIndex:"escortsIdCardNum",
        key:"escortsIdCardNum"
    },
    {
        title:'排放标准',
        dataIndex:"emissionStandard",
        key:"emissionStandard",
        slots:'emissionStandard',
    }, 
    {
        title:'创建日期',
        dataIndex:"createTime",
        key:"createTime"
    },
    {
        title:'更新日期',
        dataIndex:"updateTime",
        key:"updateTime",
    },
    {
        title: "操作",
        slots:'actions',
        width:150,
        fixed:'right'
    }
]
/**
 * 传入对象与key值，返回当前名字
 * @param {*} obj array 类型数组
 * @param {*} key key 需要变化的key值
 */
export const changeKeyToName = (obj, key) => {
  let name = ''
  obj.map(item => {
      if (item.key == key) {
          name = item.name
      }
  })
  return name
}